<template>
    <v-card class="services elevation-6" shaped>
        <v-card-title>
            <h4 style="word-break: break-word;">
                In-Patient Care
            </h4>
        </v-card-title>
        <v-divider />
        <v-container>
            <h5 style="word-break: break-word;">
                When needing to to be confined, have the peace-of-mind that you're well
                cared for at our affiliated hospital.
            </h5>
            <v-btn
                small
                class="teal accent-4 white--text my-4"
                @click="showInpatient = !showInpatient"
            >
                Read more
            </v-btn>
        </v-container>

        <!-- DIALOG BOX -->
        <Inpatient
            :show-inpatient="showInpatient"
            @showDialog="showInpatientDialog"
        />
    </v-card>
</template>

<script>
import Inpatient from '../DialogBoxes/Inpatient.vue'
export default {
    components: { Inpatient },
    data: () => ({ showInpatient: false }),
    methods: {
        showInpatientDialog(showInpatient) {
            this.showInpatient = showInpatient
        }
    }
}
</script>

<style scoped>
.services {
  text-align: justify;
  width: 250px;
}
.services h5 {
  font-weight: normal;
}

@media (max-width: 599px) {
  .services {
    margin-top: 20px;
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 1904px) {
  .services {
    margin-top: 15px;
    width: 45%;
  }
}
</style>
